import { ColorRadioGroupSkeleton, FormLayout, FormLayoutGroup, Skeleton } from "src/components"

export const CustomExteriorColorSkeleton = () => (
	<FormLayoutGroup>
		<FormLayout>
			<Skeleton.Input withLabel />
			<Skeleton.Input withLabel />
		</FormLayout>
		<ColorRadioGroupSkeleton count={13} />
		<Skeleton.RadioGroup withLabel count={3} />
		<Skeleton.Input withLabel />
	</FormLayoutGroup>
)
